import { apiCall } from "./common/base.service"
import config from "../config/application"
import permission from "./permissions.service"
import dictionary from '../config/dictionary';


class ConceptService {
  
  getConcepts = state => {
    const url = `${config.data.providers.conceptMaster.url}concept/${state}`
    return apiCall("get", url)
  }
  save = async(data) => {
    const url = `${config.data.providers.conceptMaster.url}concept/register`
    const validPermission = await concept.getPermissions(data.createdBy, dictionary.configApp.action.add)
    const error = validPermission?.response?.data?.error
    return  error ? validPermission :apiCall("post", url, data)
  }
  update = async(data) => {
    const url = `${config.data.providers.conceptMaster.url}concept/update`
    const validPermission = await concept.getPermissions(data.createdBy, dictionary.configApp.action.edit)
    const error = validPermission?.response?.data?.error
    return  error ? validPermission :apiCall("put", url, data)
  }
  getPermissions = (username, action) => {
    return permission.validPermission(
      process.env.REACT_APP_TRANSACTION_TYPE,
      username,
      process.env.REACT_APP_SYSTEM_CODE, action);

  }
  deleteConcept = async (list, username) => {
    const url = `${config.data.providers.conceptMaster.url}concept/delete`
     
    const validPermission = await concept.getPermissions(username, dictionary.configApp.action.delete)
    const error = validPermission?.response?.data?.error

    return error ? validPermission : apiCall("delete", url, list)
  }


}
const concept = new ConceptService()
export default concept
